import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

const HeaderWrapper = styled(Box)(({ theme }) => ({
  background: "linear-gradient(90deg, #AFEBD8 0%, #FFD8A8 100%)",
  padding: "2rem 1rem",
  textAlign: "center",
  color: "#FF9800",
  [theme.breakpoints.down("sm")]: {
    padding: "1.5rem 0.5rem"
  }
}));

const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "3rem",
  marginBottom: "0.5rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem"
  }
}));

const HeaderSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  color: "#333",
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem"
  }
}));

export const Header = () => {
  return (
    <HeaderWrapper>
      <HeaderTitle sx={{ fontSize: { xs: "3rem", md: "5rem" } }}>
        REQUERIX
      </HeaderTitle>
      <HeaderSubtitle sx={{ fontSize: { xs: "1.5rem", md: "2rem" }, fontWeight: "bold" }}>
        Analizá y corregí la redacción de tus requerimientos en proyectos de Ingeniería de Sistemas
      </HeaderSubtitle>
    </HeaderWrapper>
  );
};
